import { PostModalOverlayProvider } from "@circle-react/hooks/usePostModalParams";
import { useLocation, useRouter } from "@tanstack/react-router";
import { Suspense } from "react";

import { lazyWithRetry } from "@/react/helpers/lazyRetry";

import { PostModalSkeleton } from "./PostModalSkeleton";

const POST_PAGE_PATH = "/c/$spaceSlug/$postSlug" as const;

const PostModalComponent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "PostModal" */ "@circle-react/components/PostsV4/PostModal"
  ).then(module => ({ default: module.PostModalComponent })),
);

export const PostModalOverlay = () => {
  const router = useRouter();
  const maskedPathname = useLocation({
    select: location => location.maskedLocation?.pathname,
  });

  if (!maskedPathname) {
    return null;
  }

  // useMatchRoute matches the internal (background) location, not maskedLocation.
  // When a post opens as a modal from e.g. /feed, the internal route stays /feed
  // while the URL bar shows /c/$spaceSlug/$postSlug — so we match maskedPathname
  // against the route tree instead.
  const isPostPageMask = router
    .matchRoutes(maskedPathname)
    .some(match => match.fullPath === POST_PAGE_PATH);

  if (!isPostPageMask) {
    return null;
  }

  return (
    <PostModalOverlayProvider value={{ isPostModalOverlay: true }}>
      <Suspense fallback={<PostModalSkeleton />}>
        <PostModalComponent />
      </Suspense>
    </PostModalOverlayProvider>
  );
};
